import * as battery0 from '@/../images/icons/tem/battery0.svg'
import * as battery20 from '@/../images/icons/tem/battery20.svg'
import * as battery40 from '@/../images/icons/tem/battery40.svg'
import * as battery60 from '@/../images/icons/tem/battery60.svg'
import * as battery80 from '@/../images/icons/tem/battery80.svg'
import * as battery100 from '@/../images/icons/tem/battery100.svg'
import * as chp from '@/../images/icons/tem/chp.svg'
//import * as container from '@/../images/icons/tem/container.svg'
import * as wallbox from '@/../images/icons/tem/wallbox.svg'
import * as fuelcell from '@/../images/icons/tem/fuelcell.svg'
//import * as generic from '@/../images/icons/tem/generic.svg'
import * as grid from '@/../images/icons/tem/grid.svg'
//import * as heatingelement from '@/../images/icons/tem/heatingelement.svg'
import * as heatpump from '@/../images/icons/tem/heatpump.svg'
import * as pv from '@/../images/icons/tem/pv.svg'
//import * as rest from '@/../images/icons/tem/rest.svg'
//import * as trafo from '@/../images/icons/tem/trafo.svg'
import * as user from '@/../images/icons/tem/user.svg'

import { ICON_MAPPING } from './icons'

const map = {
  battery: battery0,
  battery0,
  battery20,
  battery40,
  battery60,
  battery80,
  battery100,
  chp,
  //container,
  fuelcell,
  grid,
  //heatingelement,
  heatpump,
  pv,
  //rest,
  //trafo,
  user,
  wallbox
}

export function overwriteIcons() {
  Object.assign(ICON_MAPPING, map)
}
